import { STR_ERRORS } from "../../../Common";
export function RESTResponseFormatter(response) {
    return new Promise((resolve, reject) => {
        if (!response.ok) {
            return typeof response.json === "function" ?
                response.json().then(data => reject(data)) :
                reject(STR_ERRORS.EmptyResponse);
        }
        return resolve(response.json());
    });
}
//# sourceMappingURL=RESTResponseFormatter.js.map